import { apiRequest } from "@/utils/apiRequest";
import { apiUrl } from "@/utils/apiUrl";
import { withCurrentStaff } from "@/utils/withCurrentStaff";

export class CopilotRepository {
	constructor() {
		const host = window.location.hostname;
		if (host === "localhost" || host.startsWith("192.168")) {
			this.urlBase = process.env.VUE_APP_API_BASE_URL;
		} else {
			this.urlBase = window.location.origin;
		}
	}

	async getRolesCopilot() {
		try {
			const response = await apiRequest({ url: apiUrl("/world/api/copilotrole/list"), method: "GET", throwOnNonOk: false });
			if (!response.ok) return response.status;
			return response.data;
		} catch (e) {
			console.log("Ups, algoo ha ido mal comprobando el role del usuario", e);
		}
	}

	async getTakeAway(date) {
		try {
			const response = await apiRequest({ url: apiUrl("/world/account/gettakeaway"), method: "POST", body: { date }, throwOnNonOk: true });
			return response.data;
		} catch (e) {
			console.log("Ups, algo ha ido mal en el getTakeAway");
		}
	}

	async setMessagePlayed(notificationId) {
		console.log("la notificacion desde el repo", notificationId);
		try {
			const response = await apiRequest({ url: apiUrl("/world/notification/setplayed"), method: "POST", body: { notification: notificationId }, throwOnNonOk: false });
			if (!response.ok) return response.status;
			return response.data;
		} catch (e) {
			console.log("Ups, algo ha ido dando por reproducida la notificación");
		}
	}

	async createKioskoWalkin(data) {
		try {
			const response = await apiRequest({ url: apiUrl("/world/api/kiosk/createwalkin"), method: "POST", body: data, throwOnNonOk: false });
			if (!response.ok) return response.status;
			return response.data;
		} catch (e) {
			console.log("Ups, algo ha ido mal creando el walkin desde kiosko");
		}
	}

	async createWalkin(data) {
		try {
			const response = await apiRequest({ url: apiUrl("/world/reservation/createwalkin"), method: "POST", body: data, throwOnNonOk: false });
			if (!response.ok) return response.status;
			return response.data;
		} catch (e) {
			console.log("Ups, algo ha ido mal creando el walkin desde kiosko");
		}
	}

	async registerKioskScanQr(data) {
		try {
			const response = await apiRequest({ url: apiUrl("/world/api/kiosk/register"), method: "POST", body: data, throwOnNonOk: false });
			if (!response.ok) return response.status;
			return response.data;
		} catch (e) {
			console.log("Ups, algo ha ido mal resgistrando la entrada desde el quiosco");
		}
	}

	async registerDoorLog(data) {
		try {
			const response = await apiRequest({ url: apiUrl("/world/doorlog/register"), method: "POST", body: data, throwOnNonOk: false });
			if (!response.ok) return response.status;
			return response.data;
		} catch (e) {
			console.log("Ups, algo ha ido mal resgistrando la entrada");
		}
	}

	async acknowledgeNotification(notificationId) {
		try {
			const response = await apiRequest({ url: apiUrl(`/world/api/notification/${notificationId}/ack/`), method: "POST", body: { id: notificationId }, throwOnNonOk: false });
			if (!response.ok) return response.status;
			return response.data;
		} catch (e) {
			console.log("Ups, algo ha ido validando la notificacion");
		}
	}

	async getTables() {
		try {
			const response = await apiRequest({ url: apiUrl("/world/api/tables"), method: "GET", throwOnNonOk: false });
			if (!response.ok) return response.status;
			return response.data;
		} catch (e) {
			console.log("Ups, algo ha ido mal en el getTables");
		}
	}

	async updateTable(data) {
		try {
			const response = await apiRequest({ url: apiUrl("/world/api/reservation/updatetable"), method: "POST", body: data, throwOnNonOk: false });
			if (!response.ok) return response.status;
			return response.data;
		} catch (e) {
			console.log("Ups, algo ha ido mal modificando la mesa");
		}
	}

	async updateAvailabilityProduct(data) {
		try {
			const response = await apiRequest({ url: apiUrl("/world/api/product/menu/update-availability-product"), method: "POST", body: data, throwOnNonOk: false });
			if (!response.ok) return response.status;
			return response.data;
		} catch (e) {
			console.log("Ups, algo ha ido mal actualizando el producto.");
		}
	}

	async updateTopChoiceProduct(data) {
		try {
			const response = await apiRequest({ url: apiUrl("/world/api/product/menu/update-top-choice-product"), method: "POST", body: data, throwOnNonOk: false });
			if (!response.ok) return response.status;
			return response.data;
		} catch (e) {
			console.log("Ups, algo ha ido mal actualizando el producto.");
		}
	}

	async updateProductorderDishClass(data) {
		try {
			const response = await apiRequest({ url: apiUrl("/world/api/productorder/update-dish-class"), method: "POST", body: data, throwOnNonOk: false });
			if (!response.ok) return response.status;
			return response.data;
		} catch (e) {
			console.log("Ups, algo ha ido mal actualizando el producto.");
		}
	}

	async markProductOrderAsRejected(data) {
		try {
			const response = await apiRequest({ url: apiUrl("/world/api/productorder/mark-as-rejected"), method: "POST", body: withCurrentStaff(data), throwOnNonOk: false });
			if (!response.ok) return response.status;
			return response.data;
		} catch (e) {
			console.log("No se ha podido quitar el producto");
		}
	}

	async markProductOrderAsCancelled(data) {
		try {
			const response = await apiRequest({ url: apiUrl("/world/api/productorder/mark-as-cancelled"), method: "POST", body: withCurrentStaff(data), throwOnNonOk: false });
			if (!response.ok) return response.status;
			return response.data;
		} catch (e) {
			console.log("No se ha podido quitar el producto");
		}
	}

	async markProductOrderAsLoss(data) {
		try {
			const response = await apiRequest({ url: apiUrl("/world/api/productorder/mark-as-loss"), method: "POST", body: withCurrentStaff(data), throwOnNonOk: false });
			if (!response.ok) return response.status;
			return response.data;
		} catch (e) {
			console.log("No se ha podido quitar el producto");
		}
	}

	async completeMenu(data) {
		try {
			const response = await apiRequest({ url: apiUrl("/world/api/productorder/complete-menu"), method: "POST", body: data, throwOnNonOk: false });
			if (!response.ok) return response.status;
			return response.data;
		} catch (e) {
			console.log("No se ha podido completar el menu");
			return { result: -1, message: "No se ha podido completar el menu" };
		}
	}

	async updateProductOrderPrice({ productOrderId, newPrice }) {
		const url = apiUrl(`/world/api/product-orders/${productOrderId}/price`);
		const body = {
			unitaryPrice: parseFloat(newPrice),
		};

		try {
			const response = await apiRequest({ url, method: "PATCH", body });

			if (response.ok) {
				return { result: 0, id: productOrderId };
			} else {
				return { result: -1, message: "Error updating product order price" };
			}
		} catch (e) {
			console.log("Error updating product order price", e);
			return { result: -1, message: "Error updating product order price" };
		}
	}

	async updateProductOrdersPrice({ productOrderIds, newPrice }) {
		const url = apiUrl("/world/api/product-orders/batch-price");
		const body = {
			ids: productOrderIds,
			unitaryPrice: parseFloat(newPrice),
		};

		try {
			const response = await apiRequest({ url, method: "PATCH", body, throwOnNonOk: false, expect: "text" });
			let data = null;
			if (response.data) {
				try {
					data = JSON.parse(response.data);
				} catch {
					data = { detail: response.data };
				}
			}

			if (response.ok) {
				return {
					result: 0,
					updated: data?.updated ?? productOrderIds.length,
					ids: data?.ids ?? productOrderIds,
				};
			}

			return {
				result: -1,
				message: data?.detail || data?.message || data?.["hydra:description"] || "Error updating product order prices",
			};
		} catch (e) {
			console.log("Error updating product order prices", e);
			return { result: -1, message: "Error updating product order prices" };
		}
	}

	async getStaffList() {
		try {
			const response = await apiRequest({ url: apiUrl("/world/api/staff"), method: "GET", throwOnNonOk: false });
			if (!response.ok) return response.status;
			return response.data;
		} catch (e) {
			console.log("Error obteniendo el staff", e);
			return { error: e };
		}
	}

	/**
	 * Bundled copilot init endpoint: staff, copilotRoles, tables, accountingConfig, serviceRanges.
	 * Replaces separate calls for each of these during copilot boot.
	 */
	async getCopilotInit() {
		try {
			const response = await apiRequest({ url: apiUrl("/world/api/copilot/init"), method: "GET", throwOnNonOk: false });
			if (!response.ok) {
				console.error("Error loading copilot init", response.status);
				return null;
			}
			const result = response.data;
			if (result && result.result === 0) {
				return result;
			}
			console.error("Error loading copilot init", result);
			return null;
		} catch (e) {
			console.error("Error loading copilot init", e);
			return null;
		}
	}

	async loginStaffByPin(data) {
		try {
			const response = await apiRequest({ url: apiUrl("/world/api/staff/staff-by-pin"), method: "POST", body: data, throwOnNonOk: false });
			if (!response.ok) return response.status;
			return response.data;
		} catch (e) {
			console.log("Error en login por pin", e);
			throw e;
		}
	}

	async getServiceRanges(venueId) {
		try {
			const response = await apiRequest({ url: apiUrl(`/world/api/venue/${venueId}/ranges`), method: "GET", throwOnNonOk: false });
			if (!response.ok) return response.status;
			return response.data;
		} catch (e) {
			console.log("Ups, algo ha ido mal obteniendo los rangos de servicio", e);
		}
	}

	async getStaffIncentiveGoalsProgress(staffId) {
		try {
			const response = await apiRequest({ url: apiUrl(`/world/api/staff/${staffId}/incentive-goals-progress`), method: "GET", throwOnNonOk: false });
			if (!response.ok) return response.status;
			return response.data;
		} catch (e) {
			console.log("Error obteniendo progreso de objetivos del empleado", e);
			return null;
		}
	}

	/**
	 * Register or update this device on the backend.
	 * Called fire-and-forget on every app load from the router guard.
	 *
	 * @param {object} deviceInfo - Output of deviceManager.getDeviceInfo()
	 * @returns {Promise<object|null>}
	 */
	async registerDevice(deviceInfo) {
		try {
			const response = await apiRequest({ url: apiUrl('/world/api/copilot/device/register'), method: 'POST', body: deviceInfo });
			return response.data;
		} catch (e) {
			console.warn('[CopilotRepository] Device registration failed (non-critical):', e);
			return null;
		}
	}

	/**
	 * Submit a batch of auth events to the backend.
	 * Called fire-and-forget.
	 *
	 * @param {Array<object>} events
	 * @returns {Promise<object|null>}
	 */
	async submitAuthEvents(events) {
		try {
			const response = await apiRequest({ url: apiUrl('/world/api/copilot-auth-events/batch'), method: 'POST', body: { events } });
			return response.data;
		} catch (e) {
			console.warn('[CopilotRepository] Auth event submission failed (non-critical):', e);
			return null;
		}
	}
}

export const copilotRepository = new CopilotRepository();
